import Page from "../../../components/Page"
import { Tab, Tabs } from "react-bootstrap";
import { useParams, useNavigate, Link } from "react-router-dom";
import "../../../styles/AdminSettingsPage.css";
import '../../../styles/MemberSettings.css';
import AdminSettingsTab from "./AdminSettingsTab";
import { deleteDegreeProgram, deleteEventType, deleteGender, deleteMajor, deleteMembershipRequirement, deletePronoun, deleteRace, deleteSemester, deleteShirtSize, deleteSwagItem, getDegreePrograms, getGenders, getMajors, getMembershipRequirements, getPronouns, getRaces, getSemesters, getShirtSizes, getSwagItems } from "../../../api/admin/AdminSettingsAPI";
import EditRequirementModal from "../../../components/modals/adminSettings/EditRequirementModal";
import EditSwagModal from "../../../components/modals/adminSettings/EditSwagModal";
import EditEventTypeModal from "../../../components/modals/adminSettings/EditEventTypeModal";
import EditSemesterModal from "../../../components/modals/adminSettings/EditSemesterModal";
import EditGenderModal from "../../../components/modals/adminSettings/EditGenderModal";
import EditPronounModal from "../../../components/modals/adminSettings/EditPronounModal";
import EditShirtSizeModal from "../../../components/modals/adminSettings/EditShirtSizeModal";
import EditRaceModal from "../../../components/modals/adminSettings/EditRaceModal";
import EditDegreeProgramModal from "../../../components/modals/adminSettings/EditDegreeProgramModal";
import EditMajorModal from "../../../components/modals/adminSettings/EditMajorModal";
import { getEventTypes } from "../../../api/admin/AdminDashboardAPI";
import { useAdminSettings } from "./AdminSettingsContext";


const AdminSettingsPage = () => {
    const { tab } = useParams();
    const navigate = useNavigate();

    const activeTab = tab || "semesters";

    const handleTabSelect = (key) => {
        navigate(`/admin/settings/${key}`);
    };

    const goToMembers = () => {
        navigate('/admin/members');
    };

    return (
        <Page className="w-100">
            <div className="container-fluid p-0">
                <div className="d-flex flex-row justify-content-between">
                    <h1 className="mb-3 text-start">Admin Settings</h1>
                    <Link className='link-style' style={{ textDecoration: 'none' }} to="/admin/members">
                        <div className="back-arrow" onClick={() => goToMembers()}>
                            &larr; Back
                        </div>
                    </Link>
                </div>
                <div className="p-0 w-100">
                    <Tabs
                        activeKey={activeTab}
                        onSelect={handleTabSelect}
                        id="admin-setting-tabs"
                        className="mb-3 w-100 custom-tabs"
                        >
                            <Tab eventKey="semesters" title="Semesters">
                                <div className="p-0 bg-white w-100">
                                    <AdminSettingsTab
                                        heading="Semesters"
                                        fetchData={getSemesters}
                                        modal={EditSemesterModal}
                                        labelKey="semesterTitle"
                                        sortField="startDate"
                                        deleteAPICall={deleteSemester}
                                    />
                                </div>
                            </Tab>

                            <Tab eventKey="swag" title="Swag Items">
                                <div className="p-0 bg-white w-100">
                                    <AdminSettingsTab
                                        heading="Available Swag Items"
                                        fetchData={getSwagItems}
                                        modal={EditSwagModal}
                                        labelKey="rewardName"
                                        sortField="activeSemestersRequired"
                                        deleteAPICall={deleteSwagItem}
                                    />
                                </div>
                            </Tab>

                            <Tab eventKey="members" title="Membership Requirements">
                                <div className="p-0 bg-white w-100">
                                    <AdminSettingsTab
                                        heading="Active Membership Requirements"
                                        fetchData={getMembershipRequirements}
                                        modal={EditRequirementModal}
                                        labelKey="description"
                                        sortField="position"
                                        deleteAPICall={deleteMembershipRequirement}
                                    />
                                </div>
                            </Tab>
                            
                            <Tab eventKey="eventTypes" title="Event Types">
                                <div className="p-0 bg-white w-100">
                                    <AdminSettingsTab
                                        heading="Event Types"
                                        fetchData={getEventTypes}
                                        modal={EditEventTypeModal}
                                        labelKey="eventType"
                                        sortField="eventType"
                                        deleteAPICall={deleteEventType}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="registration" title="Registration Dropdowns">
                                <div className="p-0 bg-white w-100">
                                    <div className="d-flex justify-content-evenly align-items-start">
                                        <AdminSettingsTab
                                            heading="Genders"
                                            fetchData={getGenders}
                                            modal={EditGenderModal}
                                            labelKey="dropdownValue"
                                            sortField="position"
                                            deleteAPICall={deleteGender}
                                        />
                                        <AdminSettingsTab
                                            heading="Pronouns"
                                            fetchData={getPronouns}
                                            modal={EditPronounModal}
                                            labelKey="dropdownValue"
                                            sortField="position"
                                            deleteAPICall={deletePronoun}
                                        />
                                    </div>
                                    <div className="d-flex justify-content-evenly align-items-start">
                                        <AdminSettingsTab
                                            heading="Majors"
                                            fetchData={getMajors}
                                            modal={EditMajorModal}
                                            labelKey="dropdownValue"
                                            sortField="position"
                                            deleteAPICall={deleteMajor}
                                        />
                                        <AdminSettingsTab
                                            heading="Degree Programs"
                                            fetchData={getDegreePrograms}
                                            modal={EditDegreeProgramModal}
                                            labelKey="dropdownValue"
                                            sortField="position"
                                            deleteAPICall={deleteDegreeProgram}
                                        />
                                    </div>
                                    <div className="d-flex justify-content-evenly align-items-start">
                                        <AdminSettingsTab
                                            heading="Races"
                                            fetchData={getRaces}
                                            modal={EditRaceModal}
                                            labelKey="dropdownValue"
                                            sortField="position"
                                            deleteAPICall={deleteRace}
                                        />
                                        <AdminSettingsTab
                                            heading="Shirt Sizes"
                                            fetchData={getShirtSizes}
                                            modal={EditShirtSizeModal}
                                            labelKey="dropdownValue"
                                            sortField="position"
                                            deleteAPICall={deleteShirtSize}
                                        />
                                    </div>
                                </div>
                            </Tab>
                    </Tabs>
                </div>
            </div>
        </Page>
    );
}

export default AdminSettingsPage;
